$(document).ready(function () {
    $.validator.addMethod('greaterThan', function (value, element, params) {
        if (!dayjs(value, 'Y/m/d H:i').isValid()) {
            return dayjs(value) > dayjs($(params).val());
        }
        return this.optional(element) || dayjs(value) >= dayjs($(params).val());
    }, 'Must be greater than start time/date');

    // Validate timetable events rollover form
    var TimetableRolloverForm = $('#TimetableRolloverForm');
    var startDateId = '.timetable_start';
    var endDateId = '.timetable_end';

    $(TimetableRolloverForm).validate({
        onkeyup: false,
        onclick: false,
        ignore: ':hidden, [contenteditable="true"]:not([name])',
        rules: {
            timetablestartdate: {
                required: true,
            },
            timetableenddate: {
                required: true,
                greaterThan: startDateId,
            },
            degreeprogyr: {
                required: true,
            },
        },
        messages: {
            timetablestartdate: 'Please choose the start date of your timetable rollover',
            timetableenddate: {
                required: 'Please choose the end date of your timetable rollover',
                greaterThan: 'Must be greater than start date/time',
            },
            degreeprogyr: 'Please select a programme year',
        },
        errorPlacement: function (error, element) {
            if (element.attr('name') == 'degreeprogyr')
                error.insertAfter('.degreeprogyr-error');
        },
        submitHandler: function (form) {
            form.submit();
            $('button[type="submit"]').prop('disabled', true).html('Building Timetable ... <i class="' + FontAwesome.prefix('solid', 'arrows-rotate', true) + '"></i>');
            $('#submitnotice').append('<p class="help-block"><span class="label label-danger">Note:</span> This may take several minutes</p>');
        },
    });

    // Initialise datetimepicker
    $(startDateId).datetimepicker({
        formatDate: 'Y/m/d H:i',
        defaultTime: '09:00',
        onGenerate: function (ct) {
            $(this).find('.xdsoft_date.xdsoft_weekend').addClass('xdsoft_disabled');
        },
        onShow: function (ct) {
            this.setOptions({
                maxDate: $(endDateId).val() ? $(endDateId).val() : false,
            });
        },
    });
    $(endDateId).datetimepicker({
        formatDate: 'Y/m/d H:i',
        defaultTime: '17:00',
        onGenerate: function (ct) {
            $(this).find('.xdsoft_date.xdsoft_weekend').addClass('xdsoft_disabled');
        },
        onShow: function (ct) {
            this.setOptions({
                minDate: $(startDateId).val() ? $(startDateId).val() : false,
            });
        },
    });

    $(endDateId).prop('disabled', true);
    $(startDateId).on('change', function () {
        if ($(this).val() == '') {
            if ($(endDateId).prop('disabled') === false) {
                $(endDateId).attr('value', '').val('').prop('disabled', true).datetimepicker('reset');
                setTimeout(function () {
                    $(endDateId).datetimepicker('hide');
                }, 10);
            }
        } else if ($(endDateId).prop('disabled') === true) {
            $(endDateId).prop('disabled', false);
        }
    });
});
